/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
/**
 * @ignore -- Don't include in the generated documentation
 * @internal
 */
export var STRING_STATES = [
    "pending", "resolving", "resolved", "rejected"
];
//# sourceMappingURL=state.js.map